"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.grayscale = grayscale;
var color_1 = require("../../color");
/**
 * Converts a color to grayscale.
 * @param color - The color to convert.
 * @returns A new Color instance in grayscale.
 */
function grayscale(color) {
    var _a = color.toRgb(), r = _a.r, g = _a.g, b = _a.b, a = _a.a;
    var gray = Math.round(0.299 * r + 0.587 * g + 0.114 * b);
    return new color_1.Color({ r: gray, g: gray, b: gray, a: a });
}
